import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getTopVideosHome, getSectoralData } from "../../../redux/action/common-action";
import { getEachVideoData } from "../../../redux/action/user/category";
import { parseHtml } from "../../../utils/util";

function Sarthi(props) {
  const { topVideos, getTopVideosHome, getEachVideoData, sectionData, sectoralData, getSectoralData } = props;
  const [dscVideos, setDscVideos] = useState({});
  const [firstDcVideos, setFirstDscVideos] = useState({});
  const [playerModal, setPlayerModal] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [playBtn, setPlayBtn] = useState(1);
  const [selectedVideo, setSelectedVideo] = useState({});
  const [topSection, setTopSectionData] = useState({});
  const [sarthiSection, setSarthiSection] = useState({});
  const [approachSection, setApproachSection] = useState({});
  const [chandraShow, setChandraShow] = useState({});
  const [interventionSection, setInterventionSection] = useState({});

  useEffect(() => {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.innerHTML = '!function (e, t, i) { if (void 0 === e._dyntube_v1_init) { e._dyntube_v1_init = !0; var a = t.createElement("script"); a.type = "text/javascript", a.async = !0, a.src = "https://embed.dyntube.com/v1.0/dyntube.js", t.getElementsByTagName("head")[0].appendChild(a) } }(window, document);  ';
    document.body.appendChild(s);
    document.querySelector("body").scrollTo(0, 0);
    getTopVideosHome({
      pageType: "sarthi",
    });
    getSectoralData();
    document.querySelector("body").scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (sectionData) {
      setSelectedVideo(sectionData.videoDetail);
      window.addEventListener("dyntubeReady", () => {
        setIsLoader(false);
        var player = dyntube.getPlayer(sectionData.videoDetail.videoId);
        player.play();
      });
    }
  }, [sectionData]);

  useEffect(() => {
    let videosAndCategories = topVideos?.sectionData?.videoInfo;
    if (videosAndCategories) {
      videosAndCategories = videosAndCategories.filter((item) => item.title === "DSC Show");

      if (videosAndCategories?.length > 0) {
        let videos = videosAndCategories[0]?.cards;
        setFirstDscVideos(videos.shift());
        setDscVideos(videosAndCategories[0]);
      }
    }
  }, [topVideos]);

  useEffect(() => {
    if (sectoralData?.sarthi) {
      setTopSectionData(sectoralData?.sarthi?.topSection);
      setSarthiSection(sectoralData?.sarthi?.sarthiSection);
      setApproachSection(sectoralData?.sarthi?.approachSection);
      setInterventionSection(sectoralData?.sarthi?.interventionSection);
      setChandraShow(sectoralData?.sarthi?.chandraShow);
    }
  }, [sectoralData]);

  const handleVideo = (video) => {
    console.log(video);
    setSelectedVideo({});
    setPlayerModal(true);
    setIsLoader(true);
    getEachVideoData({
      videoId: video.videoId,
      catId: video.catId,
      subCatId: video.subCatId,
    });
    window.addEventListener("dyntubeReady", () => {
      setIsLoader(false);
      // var player = dyntube.getPlayer(channelKey);
      // player.play();
    });
  };

  const handleCancel = () => {
    // setPlaying(false);
    pauseVideo();
    setTimeout(() => setPlayerModal(false), 500);
    setPlayBtn(1);
  };

  const pauseVideo = () => {
    var iframes = document.querySelectorAll("iframe");
    for (let i = 0; i < iframes.length; i++) {
      if (iframes[i] !== null) {
        var temp = iframes[i].src;
        iframes[i].src = temp;
      }
    }
  };
  return (
    <>
      <section className="grant-hero-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <Link to="/" className="grant-back-btn">
                <i className="bi bi-chevron-left"></i> {topSection?.ctaText || "Back"}
              </Link>
              <p className="h6">{topSection?.title}</p>
              <p className="h1">{topSection?.subTitle}</p>
              <p className="para w-75">{parseHtml(topSection?.desc)}</p>
              <div className="img-container">
                <img src="https://sach-public-file.s3.ap-south-1.amazonaws.com/Sactoral+Focus/Empowerment.png" alt="Hero Image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container mt-2">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="SF-Title">{sarthiSection?.title}</div>
            <div className="SF-SubTitle mb-3">{sarthiSection?.subTitle}</div>
            {/* <p className="SF-Para mb-0"> */}
            {parseHtml(sarthiSection?.desc)}
            {/* </p> */}
          </div>
        </div>
      </div>

      <div className="container mt-2">
        <div className="row g-0">
          <div className="col-md-6">
            <div className="emp-approach">
              <div className="SF-Title text-center">{approachSection?.title}</div>
              <div className="sarthi-link">
                <img className="sarthi-img" src={require("../../../static/user/img/SectoralFocus/sarthi.png").default} alt="Sarthi" />
                <img className="link-img" src={require("../../../static/user/img/SectoralFocus/icons/link.svg").default} alt="Link" />
                <div className="linksTo">{parseHtml(approachSection?.subTitle)}</div>
              </div>
              <div className="emp-link">{parseHtml(approachSection?.desc)}</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="emp-intervention">
              <div className="SF-Title text-center">{interventionSection?.title}</div>
              <div className="intervention-flow">
                {interventionSection?.subTitleData?.map((dt) => (
                  <>
                    <div className="intrvntn-item">
                      <h2>{dt.title}</h2>
                      {parseHtml(dt.desc)}
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container DSCShowWrp">
        <div className="row pb-4 align-items-center">
          <div className="col-md-8">
            <div className="h2">{chandraShow?.title}</div>
            <div className="h6">{parseHtml(chandraShow?.subTitle)}</div>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <a href="categories-inner.html" className="btn btn-sach btn-sach-linear" data-aos="zoom-in" data-aos-delay="150">
              {chandraShow?.btn}
            </a>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-6 col-lg-6">
            <div className="DSCShowVideo">
              <div className="img-wrp">
                <img src={firstDcVideos.icon} alt="DSC Show" />
              </div>
              <div className="show-cntnt">
                <h2>👉 {dscVideos.title}</h2>
                <span>{parseHtml(dscVideos.subTitle)}</span>
                <a onClick={() => handleVideo(firstDcVideos)} href="javascript:void(0);" className="btn btn-sach bg-sach">
                  <img src={require("../../../static/user/img/icons/play-icon.svg").default} alt="play-icon" className="ms-0 me-2" />
                  <span>{chandraShow?.watch}</span>
                  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <g id="Property 1=arrow-right">
                      <path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M5 13H16.865L13.232 17.36C12.878 17.784 12.936 18.415 13.36 18.768C13.785 19.122 14.415 19.064 14.769 18.64L19.769 12.64C19.808 12.593 19.827 12.538 19.856 12.486C19.88 12.444 19.909 12.408 19.927 12.362C19.972 12.247 19.999 12.126 19.999 12.004C19.999 12.003 20 12.001 20 12C20 11.999 19.999 11.997 19.999 11.996C19.999 11.874 19.972 11.753 19.927 11.638C19.909 11.592 19.88 11.556 19.856 11.514C19.827 11.462 19.808 11.407 19.769 11.36L14.769 5.36C14.57 5.123 14.286 5 14 5C13.774 5 13.547 5.076 13.36 5.232C12.936 5.585 12.878 6.216 13.232 6.64L16.865 11H5C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13Z"></path>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6">
            <div className="DSC-VideoList">
              {dscVideos?.cards?.map((item, index) => {
                return (
                  <div key={index} className="DSC-Item">
                    <div onClick={() => handleVideo(item)} className="video-thumb">
                      <img src={item.icon} alt="DSC-Video" />
                    </div>
                    <div className="video-cont">
                      <h3>{item.title}</h3>
                      <span>{item.title}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {playerModal && selectedVideo?.channelKey && (
        <Modal centered closable={true} onCancel={handleCancel} visible={true} footer={null} width={1100} className="home-hero-video">
          {isLoader && (
            <div className="row mt-lg-5 mt-3">
              <div className="col-12 text-center position-relative">
                <video className="w-100" poster={selectedVideo.icon}>
                  {/* <source src="../media/banner.mp4" type="video/mp4" /> */}
                </video>
              </div>
            </div>
          )}
          {/* <div data-dyntube-key="51v8eyn640z7a8IbyDong"></div> */}
          <div data-dyntube-key={selectedVideo.channelKey}></div>
        </Modal>
      )}
    </>
  );
}
const mapStateToProps = (state) => {
  const { CommonReducer, UserCategoryReducer } = state;
  const { params = {}, topVideos = {}, sectoralData = {} } = CommonReducer;
  const { eachVideoData = {} } = UserCategoryReducer;
  return {
    ...state,
    ...params,
    ...eachVideoData,
    topVideos,
    sectoralData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTopVideosHome: (params) => dispatch(getTopVideosHome(params)),
    getEachVideoData: (data) => dispatch(getEachVideoData(data)),
    getSectoralData: () => dispatch(getSectoralData()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sarthi);
